import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Title } from '@/Components/Preferences/PreferencesComponents/Content';
const InviteSuccess = () => {
    return (_jsxs("div", { children: [_jsx(Title, { className: "mb-2", children: "Invite processed successfully." }), _jsx("div", { className: 'mt-2', children: "If an account is found with that email, they will receive an email with your invitation." })] }));
};
export default InviteSuccess;
